import { useEffect, useState } from "react";
import { Seo } from "@/components/Seo";
import { Brush } from "@/components/brand/Lettering";
import { Mascot } from "@/components/brand/Mascot";
import { SignupForm } from "@/components/SignupForm";
import { CrewPoints } from "@/components/CrewPoints";
import { getPackPreview } from "@/lib/api";

export default function Crew() {
  const [items, setItems] = useState([]);
  useEffect(() => { getPackPreview().then(setItems).catch(() => {}); }, []);
  const stickers = items.filter((i) => i.kind === "stickers");
  const walls = items.filter((i) => i.kind === "wallpapers");
  return (
    <div className="mx-auto max-w-[1440px] px-5 pb-28 sm:px-10" data-testid="crew-page">
      <Seo title="Welcome to the Sus Crew" description="Join the Sus Crew newsletter for early drop access, Sus of the Month news and a free pack of 12 die-cut stickers and 4 phone wallpapers." path="/crew" />
      <header className="grid items-end gap-10 pb-14 pt-16 lg:grid-cols-12 lg:pt-24">
        <div className="lg:col-span-7">
          <p className="label flex items-center gap-3 font-bold"><Mascot size={30} label="" /> Free sticker pack</p>
          <h1 className="display mt-5 text-[clamp(4rem,10vw,8.5rem)]">Welcome to the <span className="hl hl-pink hl-thick">Sus Crew</span></h1>
          <Brush lines={["Stick it everywhere."]} className="mt-6 text-[clamp(2rem,4vw,3.25rem)]" />
        </div>
        <div className="rounded-[24px] border-[1.5px] border-ink bg-lime p-6 sm:p-8 lg:col-span-5" data-testid="crew-signup-box">
          <p className="font-a text-[17px]">Join with your email to unlock the download: 12 die-cut stickers (1024px PNG) and 4 phone wallpapers, plus crew early access to every drop.</p>
          <div className="mt-6"><SignupForm source="crew-page" testid="crew-signup" /></div>
        </div>
      </header>
      <section aria-labelledby="stickers-title">
        <h2 id="stickers-title" className="label font-bold">Stickers · {stickers.length}</h2>
        <div className="mt-6 grid grid-cols-3 gap-4 sm:grid-cols-4 lg:grid-cols-6" data-testid="crew-sticker-grid">
          {stickers.map((s) => <div key={s.name} className="rounded-[20px] bg-[#e6e5dd] p-3"><img src={s.src} alt={s.name.split("/")[1].replace(/^\d+-|\.png$/g, "").replace(/-/g, " ")} loading="lazy" className="aspect-square w-full object-contain" /></div>)}
        </div>
      </section>
      <section className="mt-16" aria-labelledby="walls-title">
        <h2 id="walls-title" className="label font-bold">Phone wallpapers · {walls.length}</h2>
        <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4" data-testid="crew-wallpaper-grid">
          {walls.map((w) => <img key={w.name} src={w.src} alt={`${w.name.split("-")[1]} wallpaper`} loading="lazy" className="w-full rounded-[24px] border-[1.5px] border-ink" />)}
        </div>
      </section>
      <CrewPoints />
    </div>
  );
}
